// extracted by mini-css-extract-plugin
module.exports = {"root":"ChatBotSupportListItem_root__lMbfR","listItem":"ChatBotSupportListItem_listItem__TGJ2g","icon":"ChatBotSupportListItem_icon__23FOz"};